/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { App } from "vue";

// Components
import { MdSidebar, MdNavigationItem, MdNavigationDivider, MdNavigationHeadline } from "./components/md/MdSidebar";

const registerGlobalComponents = (app: App) => {
  app.component("md-sidebar", MdSidebar);
  app.component("md-navigation-item", MdNavigationItem);
  app.component("md-navigation-divider", MdNavigationDivider);
  app.component("md-navigation-headline", MdNavigationHeadline);
}

export {
  registerGlobalComponents
};